const REVENUE_OPTIONS = [
  {
    label: '$0 - 2 Million',
    value: '2'
  },
  {
    label: '$2 - 25 Million',
    value: '25'
  },
  {
    label: '$25 - 100 Million',
    value: '100'
  },
  {
    label: '$100 - 500 Million',
    value: '500'
  },
  {
    label: '$500 - 2 Billion',
    value: '2000'
  },
  {
    label: '$ 2 Billion+',
    value: '2001'
  }
];

export { REVENUE_OPTIONS };
